import {
  Briefcase,
  Cpu,
  GraduationCap,
  HeartPulse,
  Megaphone,
  Mic,
  Newspaper,
  PiggyBank,
  Popcorn,
  ShoppingBag,
  Sprout,
  Trophy,
  type LucideIcon,
} from 'lucide-react';
import type { CampaignCategory } from '@/lib/campaigns/campaignCategories';

/**
 * One icon per campaign category, shown before the full name on the wider
 * surfaces (campaign hero, audit list, admin picker). The Record type makes a
 * new category fail to compile until it gets an icon.
 */
export const CAMPAIGN_CATEGORY_ICONS: Record<CampaignCategory, LucideIcon> = {
  business: Briefcase,
  marketing: Megaphone,
  finance: PiggyBank,
  personal_development: Sprout,
  health: HeartPulse,
  news: Newspaper,
  sports: Trophy,
  entertainment: Popcorn,
  technology: Cpu,
  education: GraduationCap,
  products: ShoppingBag,
  podcast: Mic,
};
